import { render, staticRenderFns } from "./PickSegmentationLanguageModal.vue?vue&type=template&id=0143444c&scoped=true&"
import script from "./PickSegmentationLanguageModal.vue?vue&type=script&lang=js&"
export * from "./PickSegmentationLanguageModal.vue?vue&type=script&lang=js&"
import style0 from "./PickSegmentationLanguageModal.vue?vue&type=style&index=0&id=0143444c&prod&lang=scss&"
import style1 from "./PickSegmentationLanguageModal.vue?vue&type=style&index=1&id=0143444c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143444c",
  null
  
)

export default component.exports